exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".buildingBlock.signal {\r\n  background: salmon;\r\n  color: #fff;\r\n  padding: 0.25rem 0.5rem;\r\n  margin: 0.25rem 0.25rem;\r\n  line-height: 1;\r\n  border-radius: 4px;\r\n}\r\n.buildingBlock.signal .delete {\r\n  color: #fff;\r\n  margin-left: 0.15rem;\r\n}", ""]);

// exports
